import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { type ViewSettingsSource, type ViewSettingsValues } from './view-settings';

let cardInstance = 0;

/**
 * Wook's "View settings" card: the sort and the filters of the list a rail row opens. It edits a copy and
 * hands the result back on Apply; Cancel hands back nothing, so the list stays as it was.
 */
@Component({
  selector: 'app-view-settings-card',
  imports: [ReactiveFormsModule, Button2Component],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './view-settings-card.component.html',
})
export class ViewSettingsCardComponent {
  public readonly source = input.required<ViewSettingsSource>();
  public readonly applied = output<ViewSettingsValues>();
  public readonly cancelled = output<void>();

  protected readonly id = `view-settings-${++cardInstance}`;
  protected readonly hint = computed(() => `These choices affect your ${this.source().noun} list.`);
  protected readonly form = computed(() => {
    const values = this.source().read();
    return new FormGroup({
      sort: new FormControl(values.sort, { nonNullable: true }),
      reverse: new FormControl(values.reverse, { nonNullable: true }),
      flaggedOnly: new FormControl(
        { value: values.flaggedOnly, disabled: this.source().flaggedLocked },
        { nonNullable: true },
      ),
      pinnedOnly: new FormControl(values.pinnedOnly, { nonNullable: true }),
      unreadOnly: new FormControl(values.unreadOnly, { nonNullable: true }),
    });
  });

  protected apply(): void {
    this.applied.emit(this.form().getRawValue());
  }
}
